import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, routeAccessGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // Auth
  {
    path: 'login',
    loadChildren: () =>
      import('./features/auth/auth.module').then(m => m.AuthModule),
  },

  // Custom Identity Platform "set password" page - reached from the reset-password email link
  // while signed out, so it must stay outside authGuard like login. Serves BOTH the initial
  // "create your password" email and the self-service "forgot password" email below, since
  // Identity Platform only has one password-reset email/link type for both.
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./features/auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
  },

  // Self-service "forgot password" request page (enter email -> send link). Also outside
  // authGuard - it's how a signed-out user gets to reset-password above in the first place.
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./features/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },

  // Dashboard
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [authGuard]
  },

  // Patients
  {
    path: 'patients',
    loadChildren: () =>
      import('./features/patients/patients.module').then(m => m.PatientsModule),
    canActivate: [authGuard,routeAccessGuard]
  },

  // Concentrators
  {
    path: 'concentrators',
    loadChildren: () =>
      import('./features/concentrators/concentrators.module').then(m => m.ConcentratorsModule),
    canActivate: [authGuard,routeAccessGuard]
  },

 // User Management
  {
    path: 'userManagement',
    loadChildren: () =>
      import('./features/user-management/user-management.module').then(m => m.UserManagementModule),
    canActivate: [authGuard, routeAccessGuard]
  },

  // Service Centers
  {
    path: 'serviceCenters',
    loadChildren: () =>
      import('./features/service-center/service-center.module').then(m => m.ServiceCenterModule),
    canActivate: [authGuard, routeAccessGuard]
  },

  // Organizations
  {
    path: 'organizations',
    loadChildren: () =>
      import('./features/organizations/organizations.module').then(m => m.OrganizationsModule),
    canActivate: [authGuard, routeAccessGuard]
  },

  // Device Alerts
  {
    path: 'device-alerts',
    loadChildren: () =>
      import('./features/device-alerts/device-alerts.module').then(m => m.DeviceAlertsModule),
    canActivate: [authGuard, routeAccessGuard]
  },

  // Service Requests
  {
    path: 'serviceRequests',
    loadChildren: () =>
      import('./features/service-requests/service-requests.module').then(m => m.ServiceRequestsModule),
    canActivate: [authGuard, routeAccessGuard]
  },

  //language selector
  { path: 'admin/language',
   loadChildren: () => import('./shared/components/language-selector/language-selector.module').then(m => m.LanguageSelectorModule) },

  // Fallback
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
